import { useModuleAccess } from 'context/ModuleAccessContext';
import { ModuleKeyType } from 'lib/api/company/types';
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Row,
} from 'reactstrap';

interface ModuleGuardProps {
  module: ModuleKeyType;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

const DefaultFallback: React.FC<{ moduleName: string }> = ({ moduleName }) => (
  <Row className="justify-content-center my-5">
    <Col md="8" lg="6">
      <Card className="text-center">
        <CardBody className="p-5">
          <div className="mb-4 mt-4">
            <i className="fas fa-lock fa-2x text-primary"></i>
          </div>
          <CardTitle tag="h3" className="mb-3">
            Module Access Restricted
          </CardTitle>
          <CardText className="text-muted mb-4">
            You don&apos;t have access to the{' '}
            <span className="font-weight-bold">
              {moduleName.toUpperCase() || 'requested'}
            </span>{' '}
            module.
            <br />
            Please contact your administrator if you believe this is an error.
          </CardText>
          <a href="mailto:support@securepoint360.com">
            <Button color="primary" role="a">
              Contact your administrator
            </Button>
          </a>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

export const ModuleGuard: React.FC<ModuleGuardProps> = ({
  module,
  fallback = <DefaultFallback moduleName={module} />,
  children,
}) => {
  const { isLoading, hasModule } = useModuleAccess();

  if (isLoading) return null;
  if (!hasModule(module)) return <>{fallback}</>;

  return <>{children}</>;
};
